//
// ===== File globals.ts    
//
'use strict';

export var baseApiUrl1 = 'http://localhost:4372/';
export var baseApiUrl = 'http://northwindapi.codebhagat.com/';
export var version: string = "1.0.0.0";
export var pageSize: number = 10;

// declare some global variable using with datepicker
export var languare:string = "en";


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/globals.ts